import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { addGlobalMap } from '../redux/actions/globalMaps';
import { addLayerToMap } from '../redux/actions/layersMap';
import { addBaseLayerToMap } from '../redux/actions/layersBasemap';

import { getWMSCapabilities } from '../utils/getWmsCapabilities';
import {
  GEOSERVER_WMS_URL,
  GEOSERVER_WMS_GETCAPABILITIES,
  GEOSERVER_USERNAME,
  GEOSERVER_PASSWORD,
} from '../constants/geoserver';

import baseLayers from '../constants/baseLayers';

import { Map, View } from 'ol';
import { defaults as defaultInteractions } from 'ol/interaction.js';
import { PinchZoom } from 'ol/interaction.js';

import { register } from 'ol/proj/proj4';
import { fromLonLat } from 'ol/proj';
import proj4 from 'proj4';

import 'ol/ol.css';
import 'font-gis/css/font-gis.css';
import '../scss/map.scss';

import InfoPopup from './InfoPopup';
proj4.defs('EPSG:32637', '+proj=utm +zone=37 +datum=WGS84 +units=m +no_defs');
register(proj4);

const MapComponent = () => {
  const dispatch = useDispatch();

  const map = useMemo(() => {
    // Default interaction'ları al ama PinchZoom'u özelleştir
    const interactions = defaultInteractions({
      pinchZoom: false, // Default pinchZoom'u devre dışı bırak
    });

    // Özelleştirilmiş PinchZoom ekle
    const customPinchZoom = new PinchZoom({
      constrainResolution: true, // Resolution'ı sınırla
    });
    
    interactions.push(customPinchZoom);

    return new Map({
      target: null,
      view: new View({
        projection: 'EPSG:32637',
        center: fromLonLat([38.8018, 37.1715], 'EPSG:32637'),
        //extent: [
        //  fromLonLat([37, 35], 'EPSG:32637')[0],
        //  fromLonLat([37, 35], 'EPSG:32637')[1],
        //  fromLonLat([41, 39], 'EPSG:32637')[0],
        //  fromLonLat([41, 39], 'EPSG:32637')[1],
        //],
        zoom: 9,
        // Touch event ayarları
        multiWorld: false,
        constrainResolution: true,
        enableRotation: false, // Rotasyonu devre dışı bırak
      }),
      layers: [],
      controls: [], // Mouse position kontrolünü kaldırdık
      // Özelleştirilmiş interaction'ları kullan
      interactions: interactions,
    });
  }, []);
  dispatch(addGlobalMap(map));

  useEffect(() => {
    map.setTarget('map');

    getWMSCapabilities(
      GEOSERVER_USERNAME,
      GEOSERVER_PASSWORD,
      GEOSERVER_WMS_GETCAPABILITIES,
      GEOSERVER_WMS_URL
    ).then((wmsLayers) => {
      wmsLayers.map((layer) => {
        dispatch(addLayerToMap(map,layer));
      });
    });

    baseLayers.map((baseLayer) => {
      dispatch(addBaseLayerToMap(map, baseLayer));
    });
    // Bu efektin bağımlılık dizisi eksikti; bu yüzden Redux
    // store'da herhangi bir state değişikliğinde (örn. her parsel
    // tıklamasında dispatch edilen addInfoFeature) yeniden çalışıyor,
    // WMS GetCapabilities'i tekrar çekip aynı katmanları haritaya yeniden
    // ekliyordu. Yeni eklenen bu katmanlar her seferinde en üste binip
    // parsel/ürün sorgu katmanlarını gömüyordu. Sadece bir kez (mount'ta)
    // çalışması yeterli ve doğru olan.
  }, [map, dispatch]);

  return (
    <>
      <div id="map">
        <InfoPopup />
      </div>
    </>
  );
};

export default MapComponent;
